import React from 'react';
import { Layout, Typography } from 'antd';
import FileUploader from './components/FileUploader';
import './index.css';

const { Header, Content, Footer } = Layout;
const { Title } = Typography;

const App = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ background: '#fff', padding: '0 20px' }}>
        <Title level={2} className="app-title">File Upload App</Title>
      </Header>
      
      <Content className="container">
        <FileUploader />
      </Content>
    </Layout>
  );
};

export default App; 